export default "__VITE_ASSET__3ea8c556__"